/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ role: NonNullable<unknown> }} Case_Contact_Inactive_LabelInputs */

const en_case_contact_inactive_label = /** @type {(inputs: Case_Contact_Inactive_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.role} (Inactive)`)
};

const pt_br2_case_contact_inactive_label = /** @type {(inputs: Case_Contact_Inactive_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.role} (Inativo)`)
};

/**
* | output |
* | --- |
* | "{role} (Inactive)" |
*
* @param {Case_Contact_Inactive_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_contact_inactive_label = /** @type {((inputs: Case_Contact_Inactive_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Contact_Inactive_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_contact_inactive_label(inputs)
	return pt_br2_case_contact_inactive_label(inputs)
});